export default __webpack_public_path__ + "static/media/KZ.T.08.2370 black.fe7209a8.svg";